export default (that) => [
  {
    text: that.$l('menu_label_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_edit') || '编辑展品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_delete') || '删除选品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_audit') || '展品审核',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'C',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_change') || '变更展品',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    allow: 'F',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'Y',
  },
  {
    text: that.$l('menu_label_printer') || '标签打印',
    icon: 'el-icon-printer',
    menuType: 'printer',
    divided: true,
    allow: 'P',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'Y',
  },
]
